import apiUtil from './apiUtil';
import axios from 'axios';

let pdfApi = {};

pdfApi.createPdfBoard = function(fileName, pageCount, collectionId = null) {
    let myData = {
        url: '/api/private/boards/pdf',
        method: 'POST',
        data: { fileName, pageCount, collectionId },
    };
    return apiUtil.runRequest(myData);
};

pdfApi.uploadToSignedUrl = function(signedUrl, blob, contentType) {
    return axios.put(signedUrl, blob, {
        headers: {
            'Content-Type': contentType,
        },
    });
};

pdfApi.uploadPdfFile = async function(pdfUrlPair, pdfFile) {
    await pdfApi.uploadToSignedUrl(pdfUrlPair.upload, pdfFile, 'application/pdf');
    
    return {
        download: pdfUrlPair.download,
    };
};

pdfApi.uploadThumbnail = async function(urlPair, thumbnailBlob) {
    await pdfApi.uploadToSignedUrl(urlPair.thumbnailUpload, thumbnailBlob, 'image/png');
    
    return {
        thumbnailDownload: urlPair.thumbnailDownload,
    };
};

export default pdfApi;
